// extracted by mini-css-extract-plugin
export default {"main":"Carousel_main__L6ngn"};